import { intro } from './intro';
import { equipment } from './equipment';
import { settings } from './settings';
import { ingredients } from './ingredients';
import { notes } from './notes';
import { instructions } from './instructions';

export const recipe = {
    intro: intro,
    equipment: equipment,
    settings: settings,
    ingredients: ingredients,
    instructions: instructions,
    notes: notes
}